import { render, staticRenderFns } from "./Expendpolicy_b.vue?vue&type=template&id=50dc15c8&"
import script from "./Expendpolicy_b.vue?vue&type=script&lang=js&"
export * from "./Expendpolicy_b.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports